import http from "@/plugins/Axios";
import { prepareBase64 } from "@/utils/pureFunctions.js";
import { RESOURCE_URL } from "../config";

export default {
  actions: {
    async getAttachmentFileBase64(_, { link }) {
      try {
        const {
          data: { data },
        } = await http.post(`attachment/base64/${link}?limit=100&page=0`);
        data.base64s = prepareBase64(data.base64s);
        return Promise.resolve(data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getAttachmentFile(_, address) {
      try {
        const { data } = await http.get(`${RESOURCE_URL}/files/${address}`, {
          responseType: "blob",
        });
        return Promise.resolve(data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
